import { Button } from "@mui/material";
import { ReactElement } from "react";
import { StringParam, useQueryParam } from "use-query-params";

import FullPageCard from "~frontend/components/FullPageCard";

export default function LoginError(): ReactElement {
  const [message] = useQueryParam("message", StringParam);

  return (
    <FullPageCard title="Login Error">
      <p>{message ?? "Unknown error while logging in."}</p>
      <p>
        <Button href="/auth/logout" variant="contained" color="primary">
          Try again
        </Button>
      </p>
    </FullPageCard>
  );
}
